import { render, staticRenderFns } from "./CalendarWidget.vue?vue&type=template&id=650d9a5a&scoped=true"
import script from "./CalendarWidget.vue?vue&type=script&lang=ts"
export * from "./CalendarWidget.vue?vue&type=script&lang=ts"
import style0 from "./CalendarWidget.vue?vue&type=style&index=0&id=650d9a5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650d9a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650d9a5a')) {
      api.createRecord('650d9a5a', component.options)
    } else {
      api.reload('650d9a5a', component.options)
    }
    module.hot.accept("./CalendarWidget.vue?vue&type=template&id=650d9a5a&scoped=true", function () {
      api.rerender('650d9a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarWidget.vue"
export default component.exports